import { ReactNode, useEffect } from "react"
import dynamic from "next/dynamic"
import { useAppStore } from "@/app-context"
import { IUser } from "@/services/authService"
import { ACTION } from "@/app-context/action"

const Header = dynamic(() => import('@microfrontends/app-shell-v2').then(mod => mod.Header))
const Footer = dynamic(() => import('@microfrontends/app-shell-v2').then(mod => mod.Footer))
const Container = dynamic(() => import('@microfrontends/react-components/components/Container'))
const Notification = dynamic(() => import('@/components/Notification'))
interface ILayoutProps {
    children?: ReactNode
}

const Layout = (layOutProps: ILayoutProps) => {
    const { state, props, dispatch } = useAppStore()
    
    useEffect(() => {
        const updateUser = (e: Event) => {
            const user = e.detail?.user as IUser
    
            dispatch({
                type: ACTION.SET_USER,
                payload: user
            })
        }

        window.addEventListener('UPDATE_USER', updateUser)

        return () => {
            window.removeEventListener('UPDATE_USER', updateUser)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <>
            <Header
                mode={process.env.NEXT_PUBLIC_APP_MODE as any}
                user={state.user! as any}
                langCode={props.langCode}
                pageName={state.pageName as any}
                responsive={{
                    type: 'search-page'
                }}
                isHomePage={false}
            />
            <Container>{layOutProps.children}</Container>
            <Footer
                langCode={props.langCode}
                mode={process.env.NEXT_PUBLIC_APP_MODE as any}
                user={state.user! as any}
            />
            <Notification
                langCode={props.langCode}
                user={state.user! as any}
            />
        </>
    )
}

export default Layout
